
import { useParams } from 'react-router-dom';
import ProductDetailHero from './components/ProductDetailHero';
import ProductFeatures from './components/ProductFeatures';
import ProductSpecifications from './components/ProductSpecifications';
import ComplianceSection from './components/ComplianceSection';
import RelatedProducts from './components/RelatedProducts';
import ProductCTA from './components/ProductCTA';

export default function SmokeHeatDetectorsPage() {
  const { id } = useParams();

  const product = {
    id: 2,
    title: 'Smoke & Heat Detectors',
    category: 'Fire Detection Systems',
    brand: 'FlameGuardQA',
    model: 'FG-SHD-01',
    certification: 'EN54 Certified',
    status: 'Available',
    image: 'https://readdy.ai/api/search-image?query=Professional%20white%20smoke%20and%20heat%20detector%20mounted%20on%20ceiling%20with%20red%20LED%20indicator%20light%2C%20EN54%20certified%20fire%20detection%20sensor%20with%20clean%20modern%20design%20and%20QCDD%20approval%20marking%20in%20Qatar%20commercial%20building&width=600&height=600&seq=smoke-heat-detector&orientation=squarish',
    description: 'High-sensitivity optical smoke detectors and thermal heat detectors designed for early and reliable fire detection in all environments. These advanced sensors provide dual detection capabilities for comprehensive fire protection.'
  };

  const features = [
    'Optical smoke & heat sensors for dual detection',
    'Low-profile design for easy installation',
    'Auto-reset after alarm condition clears',
    'LED alarm indicator for visual confirmation',
    'Compatible with addressable and conventional panels',
    'High sensitivity for early fire detection',
    'Drift compensation technology',
    'Easy maintenance and testing'
  ];

  const specifications = [
    { label: 'Model', value: 'FG-SHD-01' },
    { label: 'Type', value: 'Optical Smoke & Heat Detector' },
    { label: 'Operating Voltage', value: '12–24V DC' },
    { label: 'Operating Temperature', value: '-10°C to 50°C' },
    { label: 'Alarm Indicator', value: 'LED (Red)' },
    { label: 'Detection Method', value: 'Optical + Thermal' },
    { label: 'Response Time', value: '< 30 seconds' },
    { label: 'Mounting', value: 'Ceiling Mount' },
    { label: 'Dimensions', value: '100mm diameter x 50mm height' },
    { label: 'Weight', value: '150g' },
    { label: 'Certification', value: 'EN54, QCDD' },
    { label: 'Warranty', value: '3 Years' }
  ];

  const relatedProducts = [
    {
      id: 1,
      title: 'Fire Alarm Control Panel',
      image: 'https://readdy.ai/api/search-image?query=Professional%20intelligent%20fire%20alarm%20control%20panel%20with%20digital%20LCD%20display%20and%20red%20indicator%20lights%2C%20advanced%20addressable%20fire%20detection%20system%20with%20network%20connectivity%20and%20QCDD%20approval%20certification%20in%20Qatar%20commercial%20building&width=300&height=200&seq=alarm-control-panel-related&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'QCDD Approved'
    },
    {
      id: 3,
      title: 'Manual Call Points',
      image: 'https://readdy.ai/api/search-image?query=Red%20break%20glass%20manual%20fire%20alarm%20call%20point%20mounted%20on%20white%20wall%2C%20professional%20fire%20safety%20activation%20device%20with%20protective%20cover%20and%20QCDD%20approval%20marking%20in%20Qatar%20building&width=300&height=200&seq=manual-call-points-related&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'IP65 Rated'
    },
    {
      id: 4,
      title: 'Fire Alarm Sounders',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20alarm%20sounder%20and%20strobe%20light%20with%20red%20housing%2C%20QCDD%20approved%20audible%20and%20visual%20alarm%20notification%20device%20for%20Qatar%20commercial%20buildings&width=300&height=200&seq=alarm-sounders-related&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'QCDD Approved'
    },
    {
      id: 5,
      title: 'Fire Alarm Cables',
      image: 'https://readdy.ai/api/search-image?query=Professional%20fire%20alarm%20cables%20and%20wiring%20with%20red%20insulation%2C%20QCDD%20approved%20fire%20resistant%20electrical%20cables%20for%20fire%20detection%20systems%20in%20Qatar%20buildings&width=300&height=200&seq=alarm-cables-related&orientation=landscape',
      category: 'Fire Alarms',
      compliance: 'Fire Resistant'
    }
  ];

  return (
    <div className="min-h-screen">
      <ProductDetailHero product={product} />
      <ProductFeatures features={features} />
      <ProductSpecifications specifications={specifications} />
      <ComplianceSection />
      <RelatedProducts products={relatedProducts} />
      <ProductCTA />
      
      {/* Floating WhatsApp Button */}
      <div className="fixed bottom-8 right-8 z-50">
        <a 
          href="https://wa.me/97455544093"
          target="_blank"
          rel="noopener noreferrer"
          className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 flex items-center justify-center group"
        >
          <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform"></i>
        </a>
      </div>
    </div>
  );
}
